module.exports = __webpack_public_path__ + "img/nespresso_offer_banner.18a6e46.png";